import { styled } from '@raskrask-dk/rr-components'


export const StyledRedeemedCode = styled('div', {
    br: '$1',
    bgc: '$primary200',
    display: 'grid',
    gap: '$1',
    padding: '$2 $3',
    position: 'relative',
})